import { createFileRoute } from "@tanstack/react-router";
import { FormattedMessage } from "react-intl";

export const Route = createFileRoute("/_authenticated/tables/")({
	component: RouteComponent,
});

function RouteComponent() {
	return (
		<p className="text-sm text-muted-foreground">
			<FormattedMessage
				id="page.tables.index.description"
				defaultMessage="Select a table from the sidebar to view and manage records."
			/>
		</p>
	);
}
